import React from 'react';

import { env } from '@/environment';
import { concatPath } from '@/helpers/links/concat-path';

export interface CMSLinkProps {
  href: string;
  children: React.ReactNode;

  [key: string]: any;
}

export const withBaseCMSPath = (path: string) => {
  if (path.startsWith('http')) {
    return path;
  }

  return concatPath(env.CMS_BASE_URL ?? '', path);
};

const CMSLink: React.FC<CMSLinkProps> = ({ href, children, ...props }) => {
  const { className, ...restProps } = props;
  const linkHref = withBaseCMSPath(href);

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <a href={linkHref} rel="noopener noreferrer" target="_blank" className={props.className} {...restProps}>
      {children}
    </a>
  );
};

export default CMSLink;
